/**
 * Spolocne konstanty pre axiosInterceptor a AuthContext -- samostatny modul,
 * aby import AuthContextu nespustal vedlajsie efekty interceptora.
 */

// Sprava, ktorou backend odmietne token inej prevadzky (backend/middleware/auth.js).
export const TENANT_MISMATCH_MESSAGE = "Prihlásenie patrí inej prevádzke."

// Udalost na window: interceptor token zahodil, AuthContext ma zosuladit stav.
export const TENANT_MISMATCH_EVENT = "rozvozy:tenant-mismatch"

// Kod, ktorym backend oznaci 401 pri neplatnom alebo vyprsanom tokene
// (backend/middleware/auth.js). Bez neho by odhlasovala aj 401 za
// nedostatocnu rolu ci zle aktualne heslo pri zmene hesla.
export const SESSION_EXPIRED_CODE = "PRIHLASENIE_VYPRSALO"

// Udalost na window: prihlasenie vyprsalo a token je uz zahodeny.
// AuthContext odhlasi (pri act-as vrati spravcu do /sprava), Header otvori prihlasenie.
export const SESSION_EXPIRED_EVENT = "rozvozy:session-expired"

export const SESSION_EXPIRED_MESSAGE = "Prihlásenie vypršalo. Prihláste sa, prosím, znova."
